import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { EASE } from "./Motion";

export const Intro = () => {
  const [n, setN] = useState(0);
  useEffect(() => {
    const start = performance.now();
    let id;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1000);
      setN(Math.round(p * 100));
      if (p < 1) id = requestAnimationFrame(tick);
    };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, []);
  return (
    <motion.div
      className="pointer-events-none fixed inset-0 z-[100] flex flex-col justify-between bg-ink p-5 text-paper md:p-10"
      initial={{ clipPath: "inset(0 0 0% 0)" }}
      animate={{ clipPath: "inset(0 0 100% 0)" }}
      transition={{ duration: 1, ease: EASE, delay: 1.15 }}
      data-testid="intro-overlay"
    >
      <div className="flex justify-between font-mono text-[11px] uppercase tracking-[0.22em] text-stone-400">
        <span>Portfolio</span>
        <span>2009 — Present</span>
      </div>
      <div className="flex items-end justify-between">
        <span className="font-display text-[22vw] leading-[0.8] tracking-[-0.06em] tabular-nums md:text-[14vw]">{String(n).padStart(3, "0")}</span>
        <span className="font-serif text-2xl italic md:text-4xl">Ravin Patel</span>
      </div>
    </motion.div>
  );
};
